<div class="content-inner">
    <div class="form-body" [formGroup]="acuityForm" *ngIf="shiftRecord.prevShiftRecord">
        <div class="workflow-section-heading">Activity Categories</div>
        <span *ngIf="hasCensusRecords" class="enableEditing" (click)="toggleIsEditing()" role="button"><span class="icon-pencil"></span> Edit</span>
        <section class="workflow-input-group">
            <div class="workflow-input" *ngFor="let acuityCategory of acuityCategories">
                <input type="number" *ngIf="hasCensusRecords" [readonly]="!isEditing" attr.aria-label="'acuity ' + acuityCategory.id" [formControlName]="getAcuityControlName(acuityCategory.id)">
                <input type="text" *ngIf="!hasCensusRecords" attr.aria-label="'acuity ' + acuityCategory.id" value="*" disabled>
                <span class="display-label">{{ acuityCategory.name }}</span>
                <div *ngIf="hasCensusRecords && valueOutOfRange(acuityCategory.id)" class="validation-message warning">
                        Value must be greater than zero.
                </div>
            </div>   
            <div class="workflow-input totals">
                <input type="number" *ngIf="hasCensusRecords" disabled attr.aria-label="Total" [value]="acuityCensusTotal">
                <input type="text" *ngIf="!hasCensusRecords" attr.aria-label="'acuity ' + acuityCategory.id" value="*" disabled>
                <span class="display-label">Total</span>
            </div> 
            <input id="reviewed" type="checkbox" value="checkbox" formControlName="reviewed">
            <label for="reviewed">Reviewed</label>
            
            <div class="warning info" *ngIf="!hasCensusRecords">* The information recorded during the previous block is incomplete.  Please complete your missing shift block.</div>
        </section>        
    </div>
    <div *ngIf="!shiftRecord.prevShiftRecord" class="no-previous-block">
        This cost center has no previous shift block.  Please proceed to the next page.
    </div>
</div>
